import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

export default {
    name: 'lyre',
    prototype: 'items',

    info: {
        tag: [''],
        title: 'Lyre',
        description: 'Lyre',
        image: require('./lyre.png')
    },

    properties: {
        width: {
            label: 'width',
            type: 'length-measure',
            defaultValue: {
                length: 50,
                unit: 'cm'
            }
        },
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let WIDTH = element.properties.get('width') ? element.properties.get('width').get('length') : 50;
        let DEPTH = 5
        let angle = element.rotation + 90;
        let rect_style = { stroke: 'red', strokeWidth: element.selected ? '3px' : '2px', fill: "red" };
        let circleStyle = { stroke: 'red', strokeWidth: element.selected ? '3px' : '2px', fill: "white" };
        let textRotation = 0;

        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        let desc = lineBreakWord(element.desc, 20);

        return (
            <g transform={`translate(${-WIDTH / 2},${-DEPTH / 2})`}>
                <rect key="1" x="0" y="0" width={WIDTH} height={DEPTH} style={rect_style} />
                <circle key="2" cx={0} cy={3} r={5} style={circleStyle} />
                <circle key="3" cx={WIDTH} cy={3} r={5} style={circleStyle} />
                <text key="8" x="0" y="0"
                    transform={`translate(${WIDTH / 2}, ${textRotation === 0 ? -5 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {

        let WIDTH = 50; //element.properties.get('width').get('length');
        let angle = element.rotation + 90;

        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        let ribs = 5;

        let ribElements = [];
        let x = 0;
        for (let i = 0; i < ribs - 1; i++) {
            x += 20;
            ribElements.push(x);
        }

        let desc = lineBreakWord(element.desc, 20);

        let rect_style = { stroke: 'red', strokeWidth: element.selected ? '3px' : '2px', fill: "white" };

        if (element.rotation === 0) {
            return (
                <g transform={`translate(${-WIDTH / 2}, -120)`}>
                    <g transform={`translate(${-WIDTH / 2 - 10}, 50) skewX(35)`}>
                        <rect key="1" x="0" y="50" width={WIDTH} height={10} style={rect_style} />
                    </g>
                    <g transform={`translate(0, -122) skewY(55)`}>
                        <rect key="2" x={WIDTH} y="50" width="7" height="100" style={rect_style} />
                    </g>
                    <rect key="3" x="0" y="0" width={WIDTH} height="100" style={rect_style} />
                    {ribElements.map((rib, index) =>
                        <rect key={index + 2} x="0" y={rib} width="50" height="5" style={rect_style} />
                    )}
                    {element.productCount
                        ? <>
                            <path d={`M${WIDTH + 2} 30 L${WIDTH + 40} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <path d={`M${WIDTH + 40} 50 L${WIDTH + 50} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <circle id="3" cx={`${WIDTH + 60}`} cy="50" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                            <text
                                x={`${WIDTH + 60}`}
                                y="-50"
                                fontFamily="Arial"
                                alignmentBaseline="middle"
                                textAnchor="middle"
                                fontSize={24}
                                fill="#000000"
                                transform={`scale(1,-1) rotate(${textRotation})`}
                            >
                                {element.productCount}
                            </text>
                        </>
                        : <text key="8" x="0" y="0"
                            transform={`translate(${WIDTH / 2}, ${textRotation === 0 ? -5 : 15}) scale(1,-1) rotate(${textRotation})`}
                            style={{ textAnchor: "middle", fontSize: "11px" }}>
                            {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                        </text>}
                </g>
            )
        } else {
            return (
                <g transform={`rotate(${-element.rotation}), translate(${-WIDTH / 2 + 25}, -100)`}>
                    <g transform={`translate(-10, 0)`}>
                        <rect key="1" x="0" y="0" width="10" height="100" style={rect_style} />
                    </g>
                    <g transform={`translate(-40, 50) skewX(31)`}>
                        <rect key="2" x="0" y="50" width="10" height="30" style={rect_style} />
                    </g>
                    <g transform={`skewY(59)`}>
                        <rect key="3" x="0" y="0" width="18" height="100" style={rect_style} />
                        {ribElements.map((rib, index) =>
                            <rect key={index + 2} x="0" y={rib} width="18" height="5" style={rect_style} />
                        )}
                    </g>
                    {element.productCount
                        ? <>
                            <path d={`M10 50 L${WIDTH + 10} 120`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <path d={`M${WIDTH + 10} 120 L${WIDTH + 30} 120`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <circle id="3" cx={`${WIDTH + 30}`} cy="120" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                            <text
                                x={`${WIDTH + 30}`}
                                y="-120"
                                fontFamily="Arial"
                                alignmentBaseline="middle"
                                textAnchor="middle"
                                fontSize={24}
                                fill="#000000"
                                transform={`scale(1,-1) rotate(${textRotation})`}
                            >
                                {element.productCount}
                            </text>
                        </>
                        : <text key="8" x="0" y="0"
                            transform={`translate(${WIDTH / 2}, 20) scale(1,-1) rotate(-60)`}
                            style={{ textAnchor: "middle", fontSize: "11px" }}>
                            {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                        </text>}
                </g>
            )
        }
    },
};
